import React from "react"

import { BuildingTypeInput } from "shared/ui/building-type-input/BuildingTypeInput"

export interface BuildingReferenceTypeFilterInputProps {
  loading?: boolean
  disabled?: boolean
}

export const BuildingReferenceTypeFilterInput = React.memo(
  ({ loading, disabled }: BuildingReferenceTypeFilterInputProps) => {
    return (
      <BuildingTypeInput
        loading={loading}
        disabled={disabled}
        elevated
        className="building-reference-filter__building-types"
      />
    )
  }
)

BuildingReferenceTypeFilterInput.displayName =
  "BuildingReferenceTypeFilterInput"
